import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function TainanPage() {
  useSEO({
    title: '台南搬家公司推薦｜專業搬家服務｜台南市搬家費用估價 - 安心搬家',
    description: '台南搬家公司推薦首選！提供台南市37區專業搬家服務，包含中西區、東區、南區、北區、安平區、安南區等。24小時服務，免費估價，專業團隊，搬家零煩惱。立即預約台南搬家服務！',
    keywords: '台南搬家,台南搬家公司,中西區搬家,東區搬家,安平區搬家,台南市搬家費用,台南搬家推薦,台南搬家估價,永康區搬家,仁德區搬家',
    ogImage: 'https://public.readdy.ai/ai/img_res/0f0d79ce1792438a3cd524703052547e.jpg'
  });

  useEffect(() => {
    // 加入 Schema.org LocalBusiness 結構化資料
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "安心搬家 - 台南搬家服務",
      "image": "https://readdy.ai/api/search-image?query=professional%20moving%20service%20team%20carefully%20transporting%20furniture%20in%20modern%20Tainan%20city%20apartment%20with%20bright%20natural%20lighting%20and%20organized%20packing%20materials%20showing%20efficient%20relocation%20process&width=1200&height=630&seq=tainan-moving-og-001&orientation=landscape",
      "@id": "https://moving-company.com/area/tainan",
      "url": "https://moving-company.com/area/tainan",
      "telephone": "+886-2-1234-5678",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "中西區民權路二段",
        "addressLocality": "台南市",
        "postalCode": "700",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 22.9998,
        "longitude": 120.2269
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "sameAs": [
        "https://www.facebook.com/movingcompany",
        "https://www.instagram.com/movingcompany"
      ],
      "priceRange": "$$",
      "areaServed": [
        { "@type": "City", "name": "中西區" },
        { "@type": "City", "name": "東區" },
        { "@type": "City", "name": "南區" },
        { "@type": "City", "name": "北區" },
        { "@type": "City", "name": "安平區" },
        { "@type": "City", "name": "安南區" },
        { "@type": "City", "name": "永康區" },
        { "@type": "City", "name": "歸仁區" },
        { "@type": "City", "name": "新化區" },
        { "@type": "City", "name": "左鎮區" },
        { "@type": "City", "name": "玉井區" },
        { "@type": "City", "name": "楠西區" },
        { "@type": "City", "name": "南化區" },
        { "@type": "City", "name": "仁德區" },
        { "@type": "City", "name": "關廟區" },
        { "@type": "City", "name": "龍崎區" },
        { "@type": "City", "name": "官田區" },
        { "@type": "City", "name": "麻豆區" },
        { "@type": "City", "name": "佳里區" },
        { "@type": "City", "name": "西港區" },
        { "@type": "City", "name": "七股區" },
        { "@type": "City", "name": "將軍區" },
        { "@type": "City", "name": "學甲區" },
        { "@type": "City", "name": "北門區" },
        { "@type": "City", "name": "新營區" },
        { "@type": "City", "name": "後壁區" },
        { "@type": "City", "name": "白河區" },
        { "@type": "City", "name": "東山區" },
        { "@type": "City", "name": "六甲區" },
        { "@type": "City", "name": "下營區" },
        { "@type": "City", "name": "柳營區" },
        { "@type": "City", "name": "鹽水區" },
        { "@type": "City", "name": "善化區" },
        { "@type": "City", "name": "大內區" },
        { "@type": "City", "name": "山上區" },
        { "@type": "City", "name": "新市區" },
        { "@type": "City", "name": "安定區" }
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "189"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const tainanDistricts = [
    { name: '中西區', features: ['赤崁樓', '孔廟', '國華街美食'] },
    { name: '安平區', features: ['安平古堡', '漁光島', '林默娘公園'] },
    { name: '東區', features: ['台南火車站', '大東夜市', '成功大學'] },
    { name: '南區', features: ['黃金海岸', '南山公墓', '台南航空站'] },
    { name: '北區', features: ['花園夜市', '公園路', '成功路商圈'] },
    { name: '安南區', features: ['台江國家公園', '四草綠色隧道', '海尾朝皇宮'] },
    { name: '永康區', features: ['永康工業區', '奇美博物館', '永大路商圈'] },
    { name: '仁德區', features: ['奇美博物館', '高鐵台南站', '保安車站'] },
    { name: '歸仁區', features: ['歸仁文化中心', '高鐵特區', '沙崙智慧綠能科學城'] },
    { name: '新化區', features: ['新化老街', '新化林場', '果菜市場'] },
    { name: '左鎮區', features: ['化石園區', '草山月世界', '二寮日出'] },
    { name: '玉井區', features: ['芒果故鄉', '玉井老街', '白色教堂'] }
  ];

  const services = [
    {
      icon: 'ri-ancient-gate-line',
      title: '古蹟文物搬遷',
      description: '古董家具、文物藝品專業包裝搬運'
    },
    {
      icon: 'ri-building-3-line',
      title: '老屋翻新搬遷',
      description: '台南老街老屋結構熟悉，安全搬遷'
    },
    {
      icon: 'ri-restaurant-line',
      title: '餐飲店面搬遷',
      description: '小吃店、傳統美食店設備搬遷專業'
    },
    {
      icon: 'ri-government-line',
      title: '機關學校搬遷',
      description: '成功大學、各級學校、政府機關搬遷'
    }
  ];

  const faqData = [
    {
      question: '台南搬家公司推薦哪一家？',
      answer: '建鈞精緻搬家深耕台南 37 區搬家服務，熟悉古蹟周邊環境、老街巷弄限制。我們專精文物藝品、古董家具、傳統建築搬遷，擁有 4.8 分高評價，是台南古都居民推薦的搬家公司，守護古都珍貴資產。'
    },
    {
      question: '台南搬家費用怎麼算？',
      answer: '台南地區搬家費用：套房搬遷 3,000 元起（雙邊電梯優惠價），家庭搬遷 3,000-8,000 元，辦公室搬遷 5,000-20,000 元。古蹟周邊、老街區域因巷弄狹窄可能需額外費用。文物藝品搬運需現場評估。我們提供免費估價服務。'
    },
    {
      question: '台南搬家當天可以預約嗎？',
      answer: '建議提前 3-7 天預約。古蹟周邊、老街區域因交通管制較複雜，建議提前 1-2 週預約。廟會慶典、文化活動期間需避開人潮，建議提前確認時間。急件可來電 0978-900-081 詢問。'
    },
    {
      question: '台南古蹟周邊搬家要注意什麼？',
      answer: '古蹟周邊搬家需注意：1. 遵守文資法規定，不得損壞古蹟；2. 部分區域有交通管制時段；3. 巷弄狹窄需使用小型車輛；4. 避開廟會慶典和觀光人潮時段。我們熟悉古蹟保護區域通行規範，確保搬家過程符合規定。'
    },
    {
      question: '台南老屋搬家有什麼特別服務？',
      answer: '我們提供台南老屋專業搬遷服務：1. 熟悉傳統建築結構（紅磚、木樑）；2. 樓梯搬運經驗豐富；3. 古董家具特別保護；4. 文物藝品專業包裝；5. 提供文物保險保障。讓您的珍貴物品安全搬遷。'
    },
    {
      question: '台南搬家什麼時間最便宜？',
      answer: '平日（週一至週五）和非月底時段價格較優惠。避開觀光旺季（春節、連假）和廟會慶典期間，可享有更好的價格。我們也提供夜間搬家服務，避開白天觀光人潮，歡迎來電詢問優惠方案。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-50 via-white to-orange-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              台南搬家公司推薦
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              提供台南市37區專業搬家服務，24小時全年無休，免費到府估價，專業團隊讓您搬家零煩惱
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/quote"
                className="inline-flex items-center px-8 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                立即預約估價
              </Link>
              <Link
                to="/calculator"
                className="inline-flex items-center px-8 py-3 bg-white text-orange-500 font-semibold rounded-lg border-2 border-orange-500 hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calculator-line mr-2"></i>
                費用試算
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台南市 37 區完整服務</h2>
            <p className="text-xl text-gray-600">熟悉台南各區域文化特色，提供在地化專業搬家服務</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {tainanDistricts.map((district, index) => (
              <div key={index} className="bg-gradient-to-br from-teal-50 to-white border border-teal-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h3 className="font-bold text-lg text-gray-900 mb-3 flex items-center">
                  <i className="ri-map-2-line text-teal-600 mr-2"></i>
                  {district.name}
                </h3>
                <div className="space-y-1">
                  {district.features.map((feature, idx) => (
                    <div key={idx} className="text-sm text-gray-600 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-500 mr-2 text-xs"></i>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specialized Services */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台南古都特色服務</h2>
            <p className="text-xl text-gray-600">針對台南文化資產與傳統特色，提供專業搬遷解決方案</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cultural Heritage Section */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">文化資產搬遷專業</h2>
            <p className="text-xl text-gray-600">守護台南珍貴文化遺產，專業搬遷古董文物</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-gallery-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">古董藝品搬運</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                專業包裝古董家具、字畫、陶瓷等珍貴藝品，確保文物安全無損
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-white rounded-xl p-6 border border-cyan-100">
              <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-building-3-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">傳統建築熟悉</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                深度瞭解台南傳統建築結構，老屋搬遷經驗豐富，保護建築完整性
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-white rounded-xl p-6 border border-emerald-100">
              <div className="w-12 h-12 bg-emerald-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-restaurant-2-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">小吃店面搬遷</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                熟悉台南美食文化，專業搬運小吃攤位、傳統廚具設備
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-white rounded-xl p-6 border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-road-map-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">古蹟周邊通行</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                熟悉古蹟保護區域通行規範，確保搬家過程符合文資法規定
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-time-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">彈性搬遷時間</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                配合廟會慶典、文化活動時程，避開人潮壅塞時段進行搬遷
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-white rounded-xl p-6 border border-cyan-100">
              <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">文物保險保障</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                提供文物藝品專業保險，搬運過程全程保障，讓您安心託付
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 台南搬家常見問題（口語化） */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">台南搬家常見問題</h2>
            <p className="text-xl text-gray-600">最多人問的台南古都搬家問題，一次解答</p>
          </div>

          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-question-line text-teal-500"></i>
                  {faq.question}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/faq" 
              className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看更多常見問題
            </Link>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">準備在台南搬家嗎？</h2>
          <p className="text-xl mb-8 leading-relaxed">
            立即聯繫我們，獲得專業的台南古都搬家服務評估<br />
            守護珍貴文化資產，提供最專業的搬遷服務
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081"
              className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              電話諮詢：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
